import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { AppLayout } from "../-components/app-layout";

export const Route = createFileRoute("/admin")({
	component: RouteComponent,
	beforeLoad: async ({ context }) => {
		const user = context.user;

		if (!user) {
			throw redirect({ to: "/sign-in" });
		}

		if (user.role !== "admin" && user.role !== "superadmin") {
			throw redirect({ to: "/" });
		}
	},
	ssr: false,
});

function RouteComponent() {
	return (
		<AppLayout>
			<Outlet />
		</AppLayout>
	);
}
